import { render, staticRenderFns } from "./Borrower.vue?vue&type=template&id=362d1a80&scoped=true"
import script from "./Borrower.vue?vue&type=script&lang=js"
export * from "./Borrower.vue?vue&type=script&lang=js"
import style0 from "./Borrower.vue?vue&type=style&index=0&id=362d1a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d1a80",
  null
  
)

export default component.exports